//Libraries
import _ from 'lodash'

//Components
import Alert from '../../components/alert'
import Section from '../../components/section'
import IosAdd from 'react-ionicons/lib/IosAdd'
import IosClose from 'react-ionicons/lib/IosClose'
import SectionSpacing from '../../components/sectionSpacing'

//Styling
import colours from '../../utilities/colours.scss'

//Functions and Data
import config from './config'
import React, { useState } from 'react'
import { useStateValue } from './calendar.context'
import { createDates } from '../../../../modules/dates'
import { isPeak, slots, days } from '../../utilities/calendarData.js'

const initDays = days.map(day => {
  return { name: day, peak: null }
})
const initSlots = slots
  .sort((a, b) => {
    if (isNaN(a.split(':')[0]) || isNaN(b.split(':')[0])) {
      return 0
    } else {
      return Number(a.split(':')[0]) - Number(b.split(':')[0])
    }
  })
  .map(slot => {
    return { name: slot, selected: true }
  })

export default ({ sendRequest }) => {
  const [dateIndex, setDateIndex] = useState(0)
  const [alertContent, setAlertContent] = useState({})
  const [timeSlots, setTimeSlots] = useState(
    Array(7)
      .fill(0)
      .map(() => _.cloneDeep(initSlots))
  )
  const [days, setDays] = useState(initDays)

  const [{ controllers, dates }, dispatch] = useStateValue()
  const { selectedDates, userAction } = controllers

  const daysHeight = userAction === null ? 0 : 111 + selectedDates.length * 40
  const timeslotsHeight =
    userAction === null ? 0 : 151 + timeSlots[dateIndex].length * 40
  const totalHeight =
    daysHeight > timeslotsHeight ? daysHeight : timeslotsHeight

  const getDayStyle = (i, daySelected, slotSelected) => {
    var style = {}

    if (days[i].peak === null) {
      style.backgroundColor = colours.lightGray
    } else if (days[i].peak) {
      style.color = 'white'
      style.backgroundColor = colours.pink
    } else {
      style.color = 'white'
      style.backgroundColor = colours.blue
    }

    if (dateIndex === i && daySelected) {
      style.borderWidth = 2
      style.borderStyle = 'solid'
      style.borderColor = colours.darkPrimary
    }

    if (!daySelected && !slotSelected) {
      style.opacity = 0.3
    }

    return style
  }

  const changePeak = isPeak => {
    var newDays = _.cloneDeep(days)
    newDays[dateIndex].peak = isPeak

    setDays(newDays)
  }

  const toggleSlot = i => {
    var newTimeSlots = _.cloneDeep(timeSlots)
    newTimeSlots[dateIndex][i].selected = !newTimeSlots[dateIndex][i].selected

    setTimeSlots(newTimeSlots)
  }

  const create = () => {
    for (var i in days) {
      var day = days[i]
      if (day.peak === null) {
        const data = {
          title: config.warningTitle1,
          message: config.warningContent1,
          cb: () => setAlertContent({})
        }
        return setAlertContent(data)
      }
    }

    sendRequest(createDates, {
      days: days,
      timeSlots: timeSlots,
      startDate: selectedDates[0],
      endDate: selectedDates[1]
    })
    dispatch({ type: 'resetAction' })
  }

  return (
    <div className="calendarSidebar">
      {alertContent.title && <Alert content={alertContent} />}
      <Section title={config.actionsSection(userAction)} height={totalHeight}>
        <div className="calendarKeys datesActions">
          {userAction === 'selectRange' && [
            <div key={0} className="dateRow centerAlign">
              {selectedDates[0].format('DD MMM YYYY')}
            </div>,
            selectedDates.length > 1 ? (
              <div key={1} className="dateRow centerAlign">
                {'to'}
              </div>
            ) : null,
            selectedDates.length > 1 ? (
              <div key={2} className="dateRow centerAlign">
                {selectedDates[1].format('DD MMM YYYY')}
              </div>
            ) : null
          ]}
          {userAction === 'selectDates' &&
            selectedDates.map((date, i) => {
              const style = {
                backgroundColor: isPeak(date, dates)
                  ? colours.pink
                  : colours.blue,
                color: 'white'
              }
              return (
                <div key={i} className="dateRow" style={style}>
                  {date.format('DD MMM YYYY')}
                  <IosClose
                    fontSize="30px"
                    onClick={() =>
                      dispatch({
                        type: 'userAction',
                        userAction: 'selectDates',
                        selectedDate: date
                      })
                    }
                  />
                </div>
              )
            })}
          {(userAction === 'selectDates' || selectedDates.length > 1) && (
            <div className="actionButtons">
              <div
                className={
                  'themeButton actionButton3' +
                  (alertContent.title ? ' disabled' : '')
                }
                onClick={() => create()}>
                Create
              </div>
            </div>
          )}
        </div>
      </Section>
      <SectionSpacing />
      <Section title={config.timeslotsSection} height={totalHeight}>
        <div className="calendarKeys datesActions">
          <div className="slotsColumns">
            <div className="column">
              {days.map((day, i) => (
                <div
                  key={i}
                  className="dateRow"
                  style={getDayStyle(i, true)}
                  onClick={() => setDateIndex(i)}>
                  {day.name}
                </div>
              ))}
            </div>
            <div className="column">
              <div className="dayTitle">{days[dateIndex].name}</div>
              {timeSlots[dateIndex].map((slot, i) => (
                <div
                  key={i}
                  className="dateRow"
                  style={getDayStyle(dateIndex, false, slot.selected)}>
                  {slot.name}
                  {slot.selected ? (
                    <IosClose fontSize="30px" onClick={() => toggleSlot(i)} />
                  ) : (
                    <IosAdd fontSize="30px" onClick={() => toggleSlot(i)} />
                  )}
                </div>
              ))}
              <div className="actionButtons">
                <div
                  className="themeButton actionButton1"
                  onClick={() => changePeak(true)}>
                  Peak
                </div>
                <div
                  className="themeButton actionButton2"
                  onClick={() => changePeak(false)}>
                  Off Peak
                </div>
              </div>
            </div>
          </div>
          {/*(userAction === 'selectDates' || selectedDates.length > 1) && <div className="actionButtons">
            <div className="themeButton actionButton3">Change</div>
          </div>*/}
        </div>
      </Section>
    </div>
  )
}
